<template>
  <!-- Setting Item Form -->
  <b-popover
    v-if="index"
    :ref="`form-item-settings-popover-${index}`"
    :target="`form-item-settings-icon-${index}`"
    triggers="click"
    container="sidebar-group-update"
    :show.sync="popoverShow"
    placement="auto"
    @show="onShow"
  >
    <template v-slot:title>
      <div class="d-flex justify-content-between align-items-center">
        <span>字段参数配置</span>
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          class="close"
          variant="transparent"
          aria-label="Close"
          @click="onClose"
        >
          <span class="d-inline-block text-white" aria-hidden="true">&times;</span>
        </b-button>
      </div>
    </template>
    <validation-observer ref="refFormObserver">
      <b-form>
        <div ref="form" :style="{height: trHeight}" style="width: 500px;">
          <b-row v-for="(item, index) in paramArray" :key="index" ref="row">
            <b-col cols="12">
              <div class="d-flex">
                <b-row class="flex-grow-1">
                  <b-col cols="6">
                    <validation-provider mode="passive" #default="{ errors }" :name="`标题${index + 1}`" rules="required">
                      <b-form-group label="标题" :label-for="`text-${index}`" label-cols="auto">
                        <b-form-input :id="`text-${index}`" v-model="item.text" trim
                          :state="errors.length > 0 ? false:null" placeholder="标题"
                        />
                        <b-form-invalid-feedback> {{ errors[0] }} </b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                  <b-col cols="6">
                    <validation-provider mode="passive" #default="{ errors }" :name="`标识${index + 1}`" rules="required">
                      <b-form-group label="标识" :label-for="`value-${index}`" label-cols="auto">
                        <b-form-input
                          :id="`value-${index}`"
                          v-model="item.value" trim
                          :state="errors.length > 0 ? false:null"
                          placeholder="标识"
                        />
                        <b-form-invalid-feedback> {{ errors[0] }} </b-form-invalid-feedback>
                      </b-form-group>
                    </validation-provider>
                  </b-col>
                </b-row>
                <div class="d-flex justify-content-center align-items-start pt-25">
                  <b-button
                    v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                    size="sm"
                    variant="outline-warning"
                    class="btn-icon cursor-pointer ml-1 mb-1"
                    @click="removeItem(index)"
                  >
                    <feather-icon icon="XIcon" />
                  </b-button>
                </div>
              </div>
            </b-col>
          </b-row>
          <!-- add btn -->
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            size="sm"
            class="btn-icon cursor-pointer mb-1"
            variant="outline-primary"
            @click="addNewItemInItemForm"
          >
            <feather-icon icon="PlusIcon" />
          </b-button>
        </div>
      </b-form>
    </validation-observer>
    <!-- 底部操作按钮 -->
    <div class="d-flex justify-content-between pt-1 border-top">
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        size="sm"
        variant="danger"
        class="mr-1"
        @click="onClose"
      >
        取消
      </b-button>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        size="sm"
        variant="primary"
        @click="onOk"
      >
        确定
      </b-button>
    </div>
  </b-popover>
</template>

<script>
import Ripple from 'vue-ripple-directive'
import { heightTransition } from '@core/mixins/ui/transition'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { required } from '@validations'

export default {
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    index: {
      type: Number,
      default: 0,
    },
    param: {
      type: String,
      default: '[{"text":"","value":""}]',
    }
  },
  data: () => ({
    popoverShow: false,
    required,
    paramArray: [{ text: '', value: '' }]
  }),
  created() {
    window.addEventListener('resize', this.initTrHeight)
  },
  destroyed() {
    window.removeEventListener('resize', this.initTrHeight)
  },
  methods: {
    onClose() {
      this.paramArray = JSON.parse(this.param)
      this.popoverShow = false
    },
    onOk() {
      this.$refs.refFormObserver.validate().then(success => {
        if (success) {
          this.$emit('up-param', JSON.stringify(this.paramArray), this.index)
          this.popoverShow = false
        } else {
          this.initTrHeight()
        }
      })
    },
    onShow() {
      //  处理空数组情况
      if (this.param === '[]') this.paramArray = [{ text: '', value: '' }]
      else this.paramArray = JSON.parse(this.param)
      // 暂时解决刷新的问题
      setTimeout(() => { this.initTrHeight() }, 200)
      // this.initTrHeight()
    },
    addNewItemInItemForm() {
      this.$refs.form.style.overflow = 'hidden'
      this.paramArray.push({ text: '', value: '' })

      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight)
        setTimeout(() => { this.$refs.form.style.overflow = null }, 350)
      })
    },
    removeItem(index) {
      if (this.paramArray.length > 1) {
        this.paramArray.splice(index, 1)
        this.trTrimHeight(this.$refs.row[0].offsetHeight)
      } else this.$toast({
        component: ToastificationContent,
        props: {
          title: '字段参数要求',
          icon: 'BellIcon',
          text: '字段类型是单选、多选、下拉选择时候必须有参数',
          variant: 'warning',
        },
      })
    },
    initTrHeight() {
      this.trSetHeight(null)
      this.$nextTick(() => { this.trSetHeight(this.$refs.form ? this.$refs.form.scrollHeight : 0) })
    },
  },
}
</script>
<style lang="scss" scoped>
  .popover {
    max-width: 576px;
  }
</style>
